import {BaseIcon} from "./BaseIcon";

const IconDeleteButton = (props) => {
    return(

    <BaseIcon {...props}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.00002 14.6667C9.54239 14.6667 11.037 14.1319 12.2293 13.1535C13.4216 12.175 14.2377 10.8134 14.5387 9.30069C14.8396 7.78796 14.6067 6.21768 13.8796 4.85743C13.1526 3.49717 11.9764 2.4311 10.5514 1.84085C9.12645 1.25059 7.54091 1.17268 6.06495 1.62039C4.58899 2.0681 3.31393 3.01372 2.45702 4.29615C1.60011 5.57857 1.21438 7.11844 1.36554 8.65339C1.5167 10.1883 2.19541 11.6234 3.28602 12.714C4.53625 13.9643 6.23192 14.6666 8.00002 14.6667V14.6667Z" stroke="#ABABAB" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 10L10 6" stroke="#ABABAB" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 6L10 10" stroke="#ABABAB" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    </BaseIcon>
    )

}
export default IconDeleteButton